module.exports = __webpack_public_path__ + "static/img/Mat-Leckie.dfbe1d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mat-Leckie.jpg
// module id = uweV
// module chunks = 0